import hatch from '../elements/hatch.js';
hatch.register();
